import React, {Fragment, useImperativeHandle} from "react";
import { useForm } from "react-hook-form";

import { doRegisterInterest} from "root/DataFunctions/LoginFns";

// import './LoginNewUserRegistrationForm.scss';

const LoginNewUserRegistrationForm = React.forwardRef((props, ref) =>
{
    const { register, handleSubmit, watch, formState: { errors } } = useForm();

    const onSubmit = (data) => {
        doRegisterInterest( data, (response) => {

        });
    }

    useImperativeHandle(ref, () => ({
        getFormData ()
        {

        },
    }))

    const ErrorDiv = (props) =>
    {
        const style = {marginTop: '-10px', color: 'red'} ;

        return <div style={style}>{props.children}</div>
    }

    return (
        <Fragment>
            <h1 style={{textAlign: 'center'}}>Childminder Expression of Interest</h1>
            <p>Please fill in the form below to record a few basic details about yourself and we will send you login details which will give you access to all the information you need to register as a childminder.</p>
            <p>You will have access to training, videos and all the resources you need to get you going on the path to becoming a registered child minder.</p>
            <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>
                {/* register your input into the hook by invoking the "register" function */}

                <div className='row'>
                    <div className='col-md-6'>
                        <label htmlFor="firstName">First Name</label>
                        <input className='form-control' id='firstName' {...register("firstName", { required: true })} />
                        {errors.firstName && <ErrorDiv>This field is required</ErrorDiv>}
                    </div>
                    <div className='col-md-6'>
                        <label htmlFor="lastName">First Name</label>
                        <input className='form-control' id='lastName' {...register("lastName", { required: true })} />
                        {errors.lastName && <ErrorDiv>This field is required</ErrorDiv>}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-12'>
                        <label htmlFor="emailAddress">Email address</label>
                        <input className='form-control' {...register("emailAddress", { required: true })} />
                        {errors.emailAddress && <ErrorDiv>This field is required</ErrorDiv>}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-md-11'/>
                    <div className='col-md-1'>
                        <button style={{float:'right'}} type='submit' className="btn btn-icon btn-icon-right btn-small">Submit<i className="et-arrow-bold-left"/>
                        </button>
                    </div>
                </div>

            </form>
        </Fragment>
    );
});

export default LoginNewUserRegistrationForm ;
